"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        progress: {
            height: 10,
            borderRadius: 6,
            backgroundColor: theme.palette.grey[200],
        },
        needsWork: {
            backgroundColor: theme.palette.proficiency.needsWork,
        },
        inProgress: {
            backgroundColor: theme.palette.proficiency.inProgress,
        },
        mastered: {
            backgroundColor: theme.palette.proficiency.mastered,
        },
    });
});
var ProficiencyProgressBar = function (_a) {
    var _b;
    var _c = _a.value, value = _c === void 0 ? 0 : _c, other = __rest(_a, ["value"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.LinearProgress, __assign({ variant: "determinate", value: value, classes: {
            root: classes.progress,
            bar: clsx_1.default(classes.progress, (_b = {},
                _b[classes.mastered] = value >= 75,
                _b[classes.inProgress] = value >= 25 && value < 75,
                _b[classes.needsWork] = value < 25,
                _b)),
        } }, other)));
};
exports.default = ProficiencyProgressBar;
//# sourceMappingURL=ProficiencyProgressBar.js.map